import React, { Component, useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select';
import { currentDateAndTime } from '../../Constants/constants';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { NoRecords } from '../../Components/Shimmer';
import { decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';
const ExpenseMaster = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON ,permissions,setPermissions} = useContext(ConfigContext);
    const location = useLocation();
        const queryParams = new URLSearchParams(location.search);
        const encodedData = queryParams.get("abs");
        const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
        console.log("decodedData",decodedData);
    const [rows, setRows] = useState([]);
    const [parentHeaderRows, setParentHeaderRows] = useState([]);
    const [formData, setFormData] = useState({
        expenseId: "",
        expenseTitle: "",
    });
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const [isChanged, setIsChanged] = useState(false);
    const [pagination, setPagination] = useState({
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
      });
    const [errors, setErrors] = useState({});
    const [loadingPost, setLoadingPost] = useState(false);

    const getList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetExpenseList`, {
            params: {
                limit: pagination?.limit || 10,
                page: pagination?.page || 1,
            }, headers
        }).then((response) => {
            let data = response.data;
            console.log(data);
            if (response.data.success === true) {
                setPagination({
                    ...pagination,
                    next: data?.next,
                    prev: data?.prev,
                    page: data?.page,
                    total_records: data?.total_records,
                    total_pages: data?.total_pages,
                    loadingList: false,
                  });
                setRows(data?.data);
            } else {
                console.error("Error fetching list");
            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    useEffect(() => {
        getList();
    }, []);
    useEffect(() => {
        if (isChanged) {
            getList();
            setIsChanged(false);
        }
    }, [isChanged]);

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    }

    const handleToggleSwitch = () => {
        setFormData((prevData) => ({
            ...prevData,
            headerStatus: formData?.headerStatus == "1" ? "0" : "1",
        }));
    };

    const getInfo = (row) => {
        setFormData({
            ...formData, 
            expenseId: row?.expense_id,
            expenseTitle: row?.expense_title,
            errors: {}
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        // const errors = validateForm();
        // console.log("errors 1", errors);
        // if (Object.keys(errors).length > 0) {
        //     setErrors(errors);
        //     return;
        // }
        let data = {
            expense_id: formData?.expenseId,
            expense_title: formData?.expenseTitle,
            date: currentDateAndTime(),

        }

        const headers = apiHeaderJSON;
        setLoadingPost(true);
        console.log("handleSubmit ~ form Data =======>>>", formData);
        axios
            .post(`${apiURL}Masters/CreateExpense`, data, {
                headers,
            })
            .then((response) => {
                const { success } = response.data;
                console.log("handleSubmit ~ response =======>>>", response);
                if (success === true) {
                    setFormData({
                        expenseId: "",
                        expenseTitle: "",
                    });
                    getList();
                }
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick:false,
                })
                setLoadingPost(false);
            })
            .catch(function (error) {
                setLoadingPost(false);
                console.error("error", error);
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: "Oops..! Something went wrong !!",
                    icon: 'error',
                    showConfirmButton: true, 
                    allowOutsideClick:false,
                })
            });
    }

    const handleClearAll=()=>{
        setFormData({
            expenseId: "",
            expenseTitle: "",
        });
    }
    const handlePrev = () => {
        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged(true);
        }
    }
    const handleChanged = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged(true);
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Expense Master`} primary={`Home`} />
                    <div className="row">
                        <div className="col-md-5">
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Expense</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12 mt-1">
                                            <form className="row">
                                                <div className="col-md-6 mt-3">
                                                    <label htmlFor="expenseTitle" className="form-label">Expense Title</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.expenseTitle ? 'is-invalid' : ''}`}
                                                        id="expenseTitle"
                                                        name="expenseTitle"
                                                        value={formData?.expenseTitle}
                                                        disabled={(!decodedData?.includes(2) && !decodedData?.includes(3))}
                                                        onChange={(e) => handleChange("expenseTitle", e.target.value)}
                                                        placeholder="Enter Expense Title"
                                                    />
                                                    {errors.expenseTitle && <div className="text-danger">{errors.expenseTitle}</div>}
                                                </div>
                                                {/* <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                    <SubmitBtn text={ formData?.expenseId? "Update" : `Save`} type={`primary`} icon={`ri-save-line`} />
                                                </div> */}
                                                { (decodedData?.includes(2) || decodedData?.includes(3)) && (
                                                <div className="col-md-12 mt-3 mb-3 d-flex justify-content-between align-items-center" >
                                                    {!decodedData?.includes(2) && decodedData?.includes(3)  ? 
                                                        <SubmitButton onClick={(e)=>{ 
                                                            handleSubmit(e)
                                                        }}
                                                        disabled={!formData?.expenseTitle || !formData?.expenseId} loading={loadingPost}
                                                        buttonName={"Update"} loadingMessage='Loading' type='primary' icon='ri-save-line' />:
                                                        <SubmitButton onClick={(e)=>{ 
                                                            handleSubmit(e)
                                                        }}
                                                        disabled={!formData?.expenseTitle} loading={loadingPost}
                                                        buttonName={formData?.expenseId ? "Update" : "Save"} loadingMessage='Loading' type='primary' icon='ri-save-line' />
                                                    }
                                                    {formData?.expenseId && (
                                                        <SubmitButton disabled={loadingPost} onClick={handleClearAll}
                                                        buttonName="Cancel" type='secondary' icon='ri-close-line' />
                                                    )}  
                                                </div>)}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className='card'>
                                <div  style={{ "maxHeight": "65vh", "overflowY": "auto" }} className=" ">
                                    <table className={`position-relative table table-bordered table-stripped mb-0`}>
                                        <thead className='table-light sticky-top z-1'>
                                            <tr>
                                                <th>Expense Title</th>
                                                { decodedData?.includes(3) && ( 
                                                <th>Action</th>)}
                                            </tr>
                                        </thead>
                                        {rows?.length === 0 ?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <NoRecords />
                                                    </td>
                                                </tr>
                                            </tbody> :
                                            <tbody>
                                                {
                                                    rows?.map((row) => {
                                                        return <tr key={row.expense_id}>
                                                            <td>{row.expense_title}</td>
                                                            { decodedData?.includes(3) && ( 
                                                            <td className='d-flex justify-content-around'>
                                                                 { decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => {  getInfo(row)}} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                {/* <button onClick={() => this.handleDelete(row.leave_type_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                                                {/* <button type='button' onClick={() => this.setState({ leave_type_id: row.leave_type_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-info" data-bs-toggle="modal" data-bs-target="#myModal"> <i className="mdi mdi-view-list-outline fs-4"></i> </button> */}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                        }

                                    </table>
                                </div>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChanged(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {pagination?.total_records >= 1 && (
                                                <option value={pagination?.total_records}>
                                                    All
                                                </option>
                                            )}
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ExpenseMaster;
